import { render } from "./PrintComponent.vue?vue&type=template&id=31057b32&scoped=true&ts=true"
import script from "./PrintComponent.vue?vue&type=script&lang=ts"
export * from "./PrintComponent.vue?vue&type=script&lang=ts"

import "./PrintComponent.vue?vue&type=style&index=0&id=31057b32&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31057b32"]])

export default __exports__